
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `「ブラウザで開く…」をタップする`,
's182ab2d6c997515f': `ホーム画面に追加して、幅広い体験と簡単なアクセスを実現してください。`,
's224cbcec014ef6b5': `ナビゲーションバーで共有を押す`,
's233af3b7eb5e0364': `ホームに追加`,
's37a9e8aec5713460': `展開`,
's4c3161035f3a1413': `「メニュー」を押す`,
's4e1e10a6ca408245': `「ホーム画面に追加」をタップする`,
's6196153c4b0c1ea0': `インストール`,
's633502f7cff4f847': `ブラウザメニューを開く`,
's681e399d63311fba': `ギャラリーを表示`,
's6d14a4f70ba4e3cf': `共有アイコンがない場合は「メニュー」を押す`,
's922329d6f6213590': `Dockに追加`,
's9c63a79ffcc2a3a3': `「ホーム画面に追加」を押す`,
'sa2d71bfd9525168d': `「Dockに追加」を押す`,
'sa5ef80b4bb9b39f8': `折りたたむ`,
'sb527eca1c1d7e7be': `アプリ内ブラウザのメニューを開く`,
'sba52286c21552a4e': `デバイスにインストールすることで、より充実した体験と簡単なアクセスを実現できます。`,
'sc16e00a7a8b2fde2': `戻る`,
'scdaf4bbff76674c8': `ホーム画面に追加`,
'sd18a5b85f599ff3c': `コピーしたリンクをSafariで開く`,
'se72fc3a84f9b51c3': `タップしてリンクをコピー`,
'se740f75b95a51807': `ドックに追加して、幅広い体験と簡単なアクセスを実現してください。`,
'sfa6c42cdf48d93d2': `ただし、このブラウザはこの機能に対応していません。続行するには、リンクを外部ブラウザで開いてください。`,
'sfb78526365796a41': `共有メニューで「さらに表示」を押す`,
'sfea652f6580ff086': `このサイトはアプリ機能があります。`,
    };
  